/* BAD INTERFACE DESIGN (but for now ok) */
class DataHolder {
    constructor(initList) {
        this.LoadedData = null;
        this.LoadedData = initList;
    }
    async setAll(data) {
        this.LoadedData = data;
    }
    async getAll() {
        return this.LoadedData;
    }
    clear() {
        this.LoadedData = null;
    }
    DEV_directSet(data) {
        this.LoadedData = data;
    }
}
class PromiseDataHolder extends DataHolder {
    constructor() {
        super(null);
        //  this.initLoader();
    }
    initLoader() {
        this.LoadedDataPromise = this.tryLoadData();
        this.LoadedDataPromise.then(data => {
            this.setAll(data);
        }).catch(err => {
            this.failToLoad(err);
        })
            .finally(() => {
            this.LoadedDataPromise = null;
        });
    }
    async getAll() {
        if (this.LoadedDataPromise) {
            return await this.LoadedDataPromise;
        }
        return this.LoadedData;
    }
    failToLoad(err) {
        this.clear();
    }
}
function genListtDataHolder(dataHolder) {
    const oldCleaner = dataHolder.clear;
    dataHolder.clear = function clear() {
        // oldCleaner(); // TODO
        dataHolder.setAll([]);
    };
    /* dataHolder.setTargetIndex = function setTargetIndex(params:type) {
        
    } */
    dataHolder.setAll([]);
}
/* BAD INTERFACE DESIGN (but for now ok) */
export class CommonListDataHolder extends PromiseDataHolder {
    constructor(loaderAllFun, parserFun, searcherFunGen, LoadFailMesage) {
        super();
        this.loaderAllFun = loaderAllFun;
        this.parserFun = parserFun;
        this.searcherFunGen = searcherFunGen;
        this.LoadFailMesage = LoadFailMesage;
        genListtDataHolder(this); // not most beautifull, but ok
    }
    tryLoadData() {
        return this.loaderAllFun().then(async (data) => (data && Array.isArray(data)) ? await (await Promise.all(data.map(subData => this.parserFun(subData)))).filter(val => val !== null) : []);
    }
    async replace(newVal, trgKey) {
        const target = this.getByKeyInter(trgKey);
        if (!target) {
            return false;
        }
        this.setTargetIndex(newVal, target[0]);
        return true;
    }
    // TODO - realy bad design
    setTargetIndex(newVal, index) {
        if (index < 0 || index >= this.LoadedData.length) {
            return false;
        }
        this.LoadedData[index] = newVal;
        return true;
    }
    async add(data) {
        const list = await this.getAll(); // TODO bad interface
        list.push(data);
    }
    async addRaw(data) {
        return await this.add(await this.parserFun(data));
    }
    async getByKeyInter(trgKey) {
        const allEntries = await this.getAll();
        const searcherFun = this.searcherFunGen(trgKey);
        const ret = allEntries.findIndex(searcherFun);
        if (!ret) {
            return null;
        }
        return [ret, allEntries[ret]];
    }
    async getByKey(trgKey) {
        const ret = await this.getByKeyInter(trgKey);
        if (!ret) {
            return null;
        }
        return ret[1];
    }
    failToLoad(err) {
        console.warn(this.LoadFailMesage, err);
        // this.clear();
        // super.failToLoad(err);
    }
}
export class CommonSinbleDataHolder extends PromiseDataHolder {
    constructor(loaderAllFun, parserFun, LoadFailMesage) {
        super();
        this.loaderAllFun = loaderAllFun;
        this.parserFun = parserFun;
        this.LoadFailMesage = LoadFailMesage;
    }
    tryLoadData() {
        return this.loaderAllFun().then(async (data) => (data) ? await this.parserFun(data) : null);
    }
    failToLoad(err) {
        console.warn(this.LoadFailMesage, err);
        // this.clear();
        // super.failToLoad(err);
    }
}
